import { render, staticRenderFns } from "./ParkBenchSvg.vue?vue&type=template&id=6b654120&"
import script from "./ParkBenchSvg.vue?vue&type=script&lang=js&"
export * from "./ParkBenchSvg.vue?vue&type=script&lang=js&"
import style0 from "./ParkBenchSvg.vue?vue&type=style&index=0&id=6b654120&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports